/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBottleFull = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M15 22a2 2 0 0 0 2-2v-7.59a4.41 4.41 0 0 0-1.293-3.117 2.412 2.412 0 0 1-.695-1.466L15 7.59V4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v3.59c0 .639-.255 1.252-.707 1.703a4.41 4.41 0 0 0-1.287 2.897L7 12.41V20a2 2 0 0 0 2 2zM11 4h2v2h-2zm-1.962 8a2.41 2.41 0 0 1 .669-1.293A4.41 4.41 0 0 0 10.98 8h2.04a4.41 4.41 0 0 0 1.273 2.707c.354.354.584.807.669 1.293z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBottleFull as BottleFull };
